
/** 
 
 
 * */
import React from 'react';
import './RedQuickBillboard.scss';
import TitleService from 'title-service';
import RedQuickVideo from './RedQuickVideo';
import { SetMealOutlined } from '@mui/icons-material';
import { useNavigate, useParams } from 'react-router-dom';
import { Button } from '@mui/material';
import BillboardData from './BillboardData';
import NetflixBillboard from './NetflixBillboard';
import { useTheme } from '@emotion/react';
export default function RedQuickBillboard(props: {
    billboardStyle?: any,
    backgroundImage?: any,
    videoUrl?: string,
    playTitle: string,
    titleImage: string,
    description: string,
    preventPlay?: any,
    hideInfoButton?: boolean,
    playUrl: string,
    onMoreInformation?: () => void
}) {
    const navigate = useNavigate();
    let [play, setPlay] = React.useState(false);
    let [replay, setReplay] = React.useState(false);
    let [muted, setMuted] = React.useState(false);
    let [stop, setStop] = React.useState(false);
    const [visible, setVisible] = React.useState(true);
    let [showVideo, setShowVideo] = React.useState(false);
    React.useEffect(() => {
        let timeout = setTimeout(() => {
            setShowVideo(true);
            setPlay(true);
        }, 10000);
        return () => {
            clearTimeout(timeout);
        }
    }, [])
    return <NetflixBillboard dismissStatic={play}
        title={props.playTitle}
        transparentTitleImage={props.titleImage}
        backgroundImage={props.backgroundImage}
        videoUrl={props.videoUrl}
        showVideo={showVideo}
        open={showVideo}
        onVisibilityChange={(visible) => {
            setVisible(visible);
        }}
        billboardStyle={props.billboardStyle}
        description={props.description}
        hideInfoButton={props.hideInfoButton}
        videoPlaying={play && visible}
        nfpPlayer={play && visible}
        rePlay={() => {
            setShowVideo(true);
            setPlay(true);
        }}
        onEnded={() => {
            setStop(false);
            setShowVideo(false);
            setReplay(true);
            setPlay(false);
        }}
        onMoreInformation={() => {
            if (props.onMoreInformation) {
                props.onMoreInformation();
            }
        }}
        preventPlay={props.preventPlay} onPlay={() => {
            if (props.playUrl)
                navigate(props.playUrl)
        }} />
}